import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { ApiUrl } from '../constants/apiUrl';
import { CustomerTerminalMain } from '../models/entities/customer-terminal-main';
import { VCustomerTerminalMain } from '../models/entities/v-customer-terminal-main';
import { ListResponseModel } from '../models/responseModels/list-response-model';
import { ObjectResponseModel } from '../models/responseModels/object-response-model';
import { ResponseModel } from '../models/responseModels/response-model';

@Injectable({
  providedIn: 'root'
})
export class CustomerTerminalMainService {

  constructor(private httpClient: HttpClient, private router: Router, private toastrService: ToastrService) { }

  getList(): Observable<ListResponseModel<VCustomerTerminalMain>> {
    return this.httpClient.get<ListResponseModel<VCustomerTerminalMain>>(ApiUrl.url + "CustomerTerminalMain/getList");
  }

  getReport(): Observable<ListResponseModel<VCustomerTerminalMain>> {
    return this.httpClient.get<ListResponseModel<VCustomerTerminalMain>>(ApiUrl.url + "CustomerTerminalMain/getReport");
  }

  getById(id: number): Observable<ObjectResponseModel<CustomerTerminalMain>> {
    return this.httpClient.get<ObjectResponseModel<CustomerTerminalMain>>(ApiUrl.url + "CustomerTerminalMain/getById?Id=" + id);
  }

  getByContractId(contractId: number): Observable<ObjectResponseModel<CustomerTerminalMain>> {
    return this.httpClient.get<ObjectResponseModel<CustomerTerminalMain>>(ApiUrl.url + "CustomerTerminalMain/getByContractId?contractId=" + contractId);
  }

  getListByCustomerId(customerId: number): Observable<ListResponseModel<VCustomerTerminalMain>> {
    return this.httpClient.get<ListResponseModel<VCustomerTerminalMain>>(ApiUrl.url + "CustomerTerminalMain/getListByCustomerId?customerId=" + customerId);
  }

  add(customerTerminalMain: CustomerTerminalMain) {
    return this.httpClient.post<ObjectResponseModel<CustomerTerminalMain>>(ApiUrl.url + "CustomerTerminalMain/add", customerTerminalMain);
  }

  update(customerTerminalMain: CustomerTerminalMain) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "CustomerTerminalMain/update", customerTerminalMain);
  }

  delete(id: number) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "CustomerTerminalMain/delete?Id=" + id, "");
  }


}
